export default __webpack_public_path__ + "static/media/gallery-wip-emitter_02.e9889c52.jpg";